import { createAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Reset {}

export const reset = createAction<ActionType, Reset>(
    ActionType.COACHING__CA__RESET,
);
